<div *ngIf="selectedResolution != undefined" [ngClass]="isMobile == true ? 'resolutions-holder-mob' : 'resolutions-holder'">
    <!-- <div *ngFor="let choice of choices; let i = index">
      <p>{{choice.image}}</p>
    </div> -->
    <app-poll-resolution-option (selected)="select($event)" *ngFor="let choice of selectedResolution.choices| slice:0:3; let i = index" [index]="i"
                                          [isMobile]="isMobile" [choice]="choice">
    </app-poll-resolution-option>
</div>
